import {
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from '@/view/components/ui/alert-dialog'
import { Button } from '@/view/components/ui/button'
import { PartnerType } from '@/app/utils/partners.enum'
import { useEnableAndDisablePartnersController } from './useEnableAndDisablePartnersController'

interface EnableAndDisablePartnersProps {
  isActive: boolean
  id: PartnerType
}

export const EnableAndDisablePartners = ({
  isActive,
  id,
}: EnableAndDisablePartnersProps) => {
  const { handleConfirm, isPending } = useEnableAndDisablePartnersController({
    isActive,
    id,
  })

  const actionLabel = isActive ? 'Desabilitar' : 'Habilitar Produto'
  const titleAction = isActive ? 'desabilitar' : 'habilitar'

  const description = isActive
    ? 'Ao desabilitar este produto, ele deixará de aparecer para todos os usuários.'
    : 'Ao habilitar este produto, ele voltará a aparecer para todos os usuários.'

  const actionClassName = isActive
    ? 'bg-transparent border-0 text-destructive hover:bg-transparent hover:text-destructive shadow-none'
    : 'bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150'

  const cancelClassName = isActive
    ? 'my-0 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150'
    : 'my-0 bg-transparent border-0 text-destructive hover:bg-transparent hover:text-destructive shadow-none'

  const cancelLabel = isActive ? 'Manter produto' : 'Cancelar'

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <AlertDialogContent className="w-96">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Deseja {titleAction} este produto?
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex items-center justify-end w-full mt-4 gap-2 sm:justify-end sm:space-x-0">
          {isActive ? (
            <>
              <AlertDialogAction asChild>
                <Button
                  type="button"
                  onClick={handleConfirm}
                  disabled={isPending}
                  variant="ghost"
                  className={actionClassName}
                >
                  {isPending ? 'Salvando...' : actionLabel}
                </Button>
              </AlertDialogAction>
              <AlertDialogCancel
                disabled={isPending}
                className={cancelClassName}
              >
                {cancelLabel}
              </AlertDialogCancel>
            </>
          ) : (
            <>
              <AlertDialogCancel
                disabled={isPending}
                className={cancelClassName}
              >
                {cancelLabel}
              </AlertDialogCancel>
              <AlertDialogAction asChild>
                <Button
                  type="button"
                  onClick={handleConfirm}
                  disabled={isPending}
                  variant="outline"
                  className={actionClassName}
                >
                  {isPending ? 'Salvando...' : actionLabel}
                </Button>
              </AlertDialogAction>
            </>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </div>
  )
}
